// @flow @jsx h

import { bem } from '@nrk/dh-utils'
import { h } from 'preact'
import style from './index.css'

type Props = {
  playing: boolean,
  onClick: Function
}

export default function TogglePlayButton (props: Props) {
  const { playing } = props

  return (
    <button className={bem(style.voiceText__togglePlayButton, { playing })} onClick={props.onClick}>
      <span className='nrk-sr'>
        {playing ? 'Sett lyden på pause' : 'Spill av lyd'}
      </span>
      {playing ? <svg aria-hidden='true'>
        <use xlinkHref='#nrk-media-pause' />
      </svg> : <svg aria-hidden='true'>
        <use xlinkHref='#nrk-media-play' />
      </svg>}
    </button>
  )
}
